<div class="modal">
  <div class="modal-ctn">

    <div class="options">
      <input type="text" (keyup)="filter($event)">
      <img src="assets/images/close.svg" (click)="close()"/>
    </div>

    <div class="pumps">
      @for (pump of displayedPumps; track pump) {
        <div class="pump">
          <div class="logo">
            <img src="assets/images/pump.png"/>
            <a>{{ pump.pumpId }}</a>
          </div>
          <div class="info">
            <a>{{ 'PUMP.NAME' | translate }}: {{ pump.pumpName }}</a>
            <a>{{ 'PUMP.MODEL' | translate }}: {{ pump.pumpmodelName }}</a>
          </div>
          <div class="add" (click)="addPump(pump)">
            <img src="assets/images/add-shopping-cart.svg"/>
          </div>
        </div>
      }
    </div>

  </div>
</div>